// Page size and column count have to move together across the Select Image tabs, or the last row renders short.
export const GRID_PAGE_SIZE = 18;
export const GRID_COLUMNS = 6;
export const GRID_COLUMNS_MD = 3;

// Product picker only. Four columns and two full rows fit the dialog; a third row would scroll.
export const PRODUCT_PICKER_COLUMNS = 4;
export const PRODUCT_PICKER_PAGE_SIZE = PRODUCT_PICKER_COLUMNS * 2;
